module.exports = __webpack_public_path__ + "img/down-gd2.aabe1502.png";